import { AiOutlineLoading } from "react-icons/ai";
import { Accordion, Alert, Button } from "flowbite-react";
import { useForm } from "react-hook-form";
import { ADMIN } from "../../config/apiConfig";
import axios from "../../config/axiosInstance";
import { useEffect, useState } from "react";
import { HiInformationCircle } from "react-icons/hi";
import { useQuery } from "react-query";
import Input from "../inputs/Input";
import DrawerLoading from "../DrawerLoading";
import CurrencyInput from "../inputs/CurrencyInput";

const AdditionalTableQueriesForm = ({
  fetchCompanies,
  onClose,
  company,
  type,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const { isLoading: isLoadingAvailableQueries, data: availableQueries } =
    useQuery(["queries-with-additional"], async () => {
      const { data } = await axios.get(ADMIN.GET_QUERIES_WITH_ADDITIONAL);
      return data.data;
    });

  const { isLoading: isLoadingCompanyQueries, data: companyAdditionalQueries } =
    useQuery(
      ["additional-company-queries", company?.id],
      async () => {
        const { data } = await axios.get(
          `${ADMIN.GET_ADDITIONAL_COMPANY_QUERIES}/${company?.id}`
        );
        return data.data;
      },
      { enabled: !!company?.id } // só busca se tiver selectedTable
    );
  const {
    register,
    setValue,
    watch,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (!availableQueries) return;

    reset();
    setError(null);

    availableQueries.forEach((query, idxQuery) => {
      query.additionalQueries.forEach((addQuery, idxAdd) => {
        const path = `queries[${idxQuery}].additionalQueries[${idxAdd}]`;

        // Sempre definir o ID
        setValue(`${path}.additionalQueryId`, addQuery.id);

        // Busca o item correspondente pelo AdditionalQueryId
        const matched = companyAdditionalQueries?.find(
          (item) => item.AdditionalQueryId === addQuery.id
        );

        setValue(`${path}.isActive`, matched ? true : false);
        setValue(`${path}.price`, matched?.price ?? addQuery.price);
      });
    });
  }, [availableQueries, companyAdditionalQueries, company]);

  const onSubmit = async (data) => {
    try {
      setIsSubmitting(true);

      const additionalQueries = [];

      data.queries?.forEach((query) => {
        query.additionalQueries?.forEach((item) => {
          if (item.isActive) {
            additionalQueries.push({
              AdditionalQueryId: item.additionalQueryId,
              price: item.price,
            });
          }
        });
      });

      data.additionalCompanyQueries = additionalQueries;

      if (company) {
        await axios.put(
          `${ADMIN.GET_ADDITIONAL_COMPANY_QUERIES}/${company.id}`,
          data
        );
      }

      fetchCompanies();
      onClose(false);
    } catch (error) {
      setError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <form className="mb-6" onSubmit={handleSubmit(onSubmit)}>
        {availableQueries?.length > 0 ? (
          <>
            <Accordion style={{ maxWidth: "600px" }}>
              {availableQueries.map((query, idxQuery) => (
                <Accordion.Panel key={idxQuery}>
                  <Accordion.Title>{query.name}</Accordion.Title>
                  <Accordion.Content>
                    <div className="flex flex-col gap-4">
                      {query.additionalQueries?.map((item, idxAdd) => (
                        <div key={idxAdd}>
                          <div className="flex justify-between items-center">
                            <label className="flex items-center gap-3">
                              <div>
                                <input
                                  type="checkbox"
                                  className="sr-only peer"
                                  {...register(
                                    `queries[${idxQuery}].additionalQueries[${idxAdd}].isActive`
                                  )}
                                />

                                <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 dark:bg-gray-700 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-700"></div>
                              </div>
                              <span className="text-sm font-medium text-gray-900 dark:text-gray-300">
                                {item.name}
                              </span>
                            </label>
                            <CurrencyInput
                              control={control}
                              register={register}
                              name={`queries[${idxQuery}].additionalQueries[${idxAdd}].price`}
                              className="w-30"
                              label="Preço"
                            />
                          </div>
                          <input
                            type="hidden"
                            {...register(
                              `queries[${idxQuery}].additionalQueries[${idxAdd}].additionalQueryId`
                            )}
                          />
                          <hr className="mt-4" />
                        </div>
                      ))}
                    </div>
                  </Accordion.Content>
                </Accordion.Panel>
              ))}
            </Accordion>

            <Button
              type="submit"
              className="w-full mb-48 md:mb-4 primary mt-6"
              isProcessing={isSubmitting}
              processingSpinner={
                <AiOutlineLoading className="h-6 w-6 animate-spin" />
              }
              disabled={isSubmitting}
            >
              {type === "CREATE" ? "Criar" : "Atualizar"} tabela
            </Button>

            {error && (
              <Alert color="failure" icon={HiInformationCircle}>
                Erro ao salvar tabela de adicionais
              </Alert>
            )}
          </>
        ) : (
          <div className="text-sm md:text-md text-center">
            Nenhuma consulta adicional encontrada.
          </div>
        )}
      </form>

      {(isLoadingAvailableQueries || isLoadingCompanyQueries) && (
        <DrawerLoading />
      )}
    </>
  );
};

export default AdditionalTableQueriesForm;
